import axios from "axios";

const baseUrl = `${process.env.REACT_APP_TOGETHER_BACKEND_HOST}`;

/**
 * 카테고리별 컨텐츠 목록 조회하기
 * @param param
 * @param param.catetgoryId 0 - 없음 | 1 - 소통글 | 2 - 클래스 | 3 - 공동구매 | 4 - 영양제 추천
 * @param param.userId partners_id
 * @param param.offset
 * @param param.pageSize
 * @returns {Promise<never>}
 */
const getContentsByCategory = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/partners/read/content/list/all`,
    {
      params: param,
    },
  );
  return data;
};
const togetherApi = {
  getContentsByCategory,
};

export default togetherApi;
